import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router';
import styles from './Login.module.css';

const API = import.meta.env.VITE_API_URL || '/api';

export function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const isSetup = searchParams.get('setup') === '1';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('パスワードは8文字以上で設定してください');
      return;
    }
    if (password !== confirmPassword) {
      setError('パスワードが一致しません');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'パスワードの更新に失敗しました');
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'パスワードの更新に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className={styles.page}>
        <div className={styles.card}>
          <div className={styles.logo}>
            <div className={styles.logoIcon}>ME</div>
            <div className={styles.logoText}>住縁 Mirai EMS</div>
          </div>
          <div className={styles.subtitle}>{isSetup ? '初期パスワード設定' : 'パスワードリセット'}</div>
          <div className={styles.error}>{isSetup ? '無効なセットアップリンクです。管理者にお問い合わせください。' : '無効なリセットリンクです'}</div>
          <Link to="/forgot-password" style={{ display: 'block', fontSize: 12, color: 'var(--brand)', textAlign: 'center', marginTop: 16 }}>
            {isSetup ? 'ログイン画面へ' : 'パスワードリセットを再申請する'}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}>ME</div>
          <div className={styles.logoText}>住縁 Mirai EMS</div>
        </div>
        <div className={styles.subtitle}>{isSetup ? '初期パスワード設定' : '新しいパスワードを設定'}</div>
        {isSetup && !done && (
          <p style={{ fontSize: 12, color: 'var(--ink2)', lineHeight: 1.7, marginBottom: 16, background: 'var(--surface2, #f4f3ef)', padding: '10px 14px', borderRadius: 8 }}>
            住縁 Mirai EMS へようこそ！<br />ログイン用のパスワードを設定してください。
          </p>
        )}

        {done ? (
          <>
            <p style={{ fontSize: 13, color: 'var(--ink2)', lineHeight: 1.7, marginBottom: 20 }}>
              {isSetup ? 'パスワードの設定が完了しました！' : 'パスワードが更新されました。'}<br />
              {isSetup ? '設定したパスワードでログインしてください。' : '新しいパスワードでログインしてください。'}
            </p>
            <Link to="/login" className={styles.btn} style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }}>
              ログイン画面へ
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.field}>
              <label className={styles.label}>{isSetup ? 'パスワード' : '新しいパスワード'}</label>
              <input className={styles.input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} autoFocus placeholder="8文字以上" />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>パスワード確認</label>
              <input className={styles.input} type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={8} placeholder="もう一度入力" />
            </div>
            {error && <div className={styles.error}>{error}</div>}
            <button className={styles.btn} type="submit" disabled={loading}>
              {loading ? '設定中...' : isSetup ? 'パスワードを設定してログイン' : 'パスワードを更新'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
